// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoicePreviewResponseSchema = z.object({
  invoices_count: z.number().int().describe("Number of invoices to be created"),
  project_ids: z.array(z.object({})).describe("Project totals"),
  skipped_client_ids: z.array(z.object({
    id: z.number().int(),
    error: z.coerce.string().min(1),
  })).describe("Clients skipped"),
  skipped_project_ids: z.array(z.object({
    id: z.number().int(),
    error: z.coerce.string().min(1),
  })).describe("Projects skipped"),
  error: z.coerce.string().describe("Error message if any").nullish(),
});
